export const lcTextCardStandard = {
  __typename: 'ComponentLearningCenterTextCard',
  content: {
    json: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Great description',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  title: 'Test Title',
};
